import React from 'react';
import { IAuditoriaBaixaPatrimonialResultado } from '../interfaces/IAuditoriaBaixaPatrimonial';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaBaixaPatrimonialResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Baixa Direta (Alienação/Perda) de Ativo Imobilizado não é um tributo — é uma
// auditoria complementar que reúne duas análises (sem contrapartida no resultado, sem
// identificação do bem no histórico). Segue o mesmo padrão de seção própria já usado para
// Depreciação, Caixa, Financeira e Zeramento de 13º Salário.
const AuditoriaResumoBaixaPatrimonial: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias =
    (resultado.baixasSemContrapartida?.length || 0) +
    (resultado.baixasSemIdentificacao?.length || 0);

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Baixa Direta de Ativo Imobilizado</h3>
      <p className='text-muted'>
        Auditoria complementar — a baixa (alienação/perda) de um bem do Ativo Imobilizado deve transitar pelo resultado
        do período (CPC 27) e permitir a identificação do bem baixado. Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_BAIXA_PATRIMONIAL')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Baixa Direta de Ativo Imobilizado</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} baixa{totalOcorrencias === 1 ? '' : 's'} com indício identificado no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multas de 3% por inexatidão no SPED (Art. 12 da Lei nº 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoBaixaPatrimonial;
